/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 22/11/21
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import WrapperFieldType from '@/modules/templates/components/Registers/TemplateSectionsDrawer/components/WrapperFieldType';
import {useTranslation} from 'react-i18next';

const SectionBox = ({section, id}) => {
  const {t} = useTranslation('templates');
  return (
    <div id={id}>
      {section?.params?.length === 0
        ? <div className="w-full flex items-center justify-center min-h-8 py-4">{t('noParamsOrFieldsForThisSection')}</div>
        : section?.params?.map(item => {
          return <WrapperFieldType key={item?._id} type={item?.type} fieldType={item?.parameter?.fieldType} parameter={item} sectionId={section?._id}/>;
        })}
    </div>
  );
};

SectionBox.propTypes = {
  section: PropTypes.object,
  id: PropTypes.string,
};

export default memo(SectionBox);
